import { useEffect, useState } from 'react';
import { Box, Alert, AlertTitle, Paper } from '@mui/material';
import { CloudOff } from '@mui/icons-material';
import { subscribeToServiceWorkerState, getServiceWorkerState } from '../utils/serviceWorker';

export default function OfflineIndicator() {
  const [isOffline, setIsOffline] = useState(getServiceWorkerState().offline);

  useEffect(() => {
    const unsubscribe = subscribeToServiceWorkerState((state) => {
      setIsOffline(state.offline);
    });

    return unsubscribe;
  }, []);

  if (!isOffline) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: 1,
      }}
    >
      <Paper elevation={3}>
        <Alert 
          severity="warning" 
          icon={<CloudOff />}
          sx={{
            borderRadius: 1,
          }}
        >
          <AlertTitle>You are offline</AlertTitle>
          No internet connection detected. Some features may be limited. 
          Data changes are blocked to prevent sync issues.
        </Alert>
      </Paper>
    </Box>
  );
}
